import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { faAdd, faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getAllApi,
  getHomeData,
  updateHomeData,
  uploadImageApi,
} from "../../api";
import InputField from "../../components/inputField/inputField";
import Modal from "../../components/modal/modal";
import toast from "react-hot-toast";
import TextEditor from "../../components/textEditor/textEditor";
import he from "he";
import { isValidURL } from "../../utils/isValidUrl";

const Home = () => {
  const navigate = useNavigate("");
  const [hero, setHero] = useState([]);
  const [grid, setGrid] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [deleteFrom, setDeleteFrom] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [modal, setModal] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [formImage, setFormImage] = useState({ url: "", obj: "" });
  const [formImageCaption, setFormImageCaption] = useState("");
  const [formImageAlt, setFormImageAlt] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [contactQuestions, setContactQuestions] = useState([]);
  const [tempKey, setTempKey] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [bottomSection, setBottomSection] = useState({
    left: {
      heading: "",
      buttonText: "",
      buttonUrl: "",
    },
    right: {
      heading: "",
      buttonText: "",
      buttonUrl: "",
    },
  });

  useEffect(() => {
    getBlogs();
  }, []);

  const getBlogs = () => {
    getAllApi("article")
      .then((response) => {
        setBlogs(response.data);
        getData();
      })
      .catch((error) => {
        setBlogs([]);
        toast.error("Something went wrong while fetching blogs.");
        getData();
      });
  };

  const getData = async () => {
    try {
      const res = await getHomeData();

      if (res.data.length !== 0) {
        console.log(res.data[0]);
        setHero(res.data[0].heroCarousel);
        setGrid(res.data[0].gridSection);
        setNumbers(res.data[0].numbers);
        setClients(res.data[0].client);
        setId(res.data[0]._id);

        setFormImage({ url: res.data[0]?.question?.image, obj: "" });
        setFormImageCaption(res.data[0]?.question?.imageCaption);
        setFormImageAlt(res.data[0]?.question?.imageAlt);
        setFormTitle(res.data[0]?.question?.title);
        setFormDescription(he.decode(res.data[0]?.question.description));

        setRelatedBlogs(res.data[0]?.relatedArticle || []);

        setContactQuestions(
          res.data[0]?.contactQuestions?.map((v) => ({
            question: v?.question || "",
            options: v?.options || [],
            tempText: "",
          }))
        );

        setBottomSection(
          res.data[0]?.bottomSection || {
            left: { heading: "", buttonText: "", buttonUrl: "" },
            right: { heading: "", buttonText: "", buttonUrl: "" },
          }
        );

        setMetaTitle(res.data[0]?.metaData?.metaTitle || "");
        setMetaImageUrl(res.data[0]?.metaData?.metaImageUrl || "");
        setCanonicalUrl(res.data[0]?.metaData?.canonicalUrl || "");
        setMetaDescription(res.data[0]?.metaData?.metaDescription || "");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleDelete = () => {
    setModal(false);
    setLoading(true);

    if (deleteFrom === "hero") {
      if (hero.length === 1) {
        updateHomeData({ heroCarousel: [] }, id)
          .then(() => {
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      } else {
        updateHomeData(
          {
            heroCarousel: hero.filter((val) => val._id !== deleteId),
          },
          id
        )
          .then(() => {
            toast.success("Deleted Successfully.");
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      }
    }

    if (deleteFrom === "grid") {
      if (grid.length === 1) {
        updateHomeData({ gridSection: [] }, id)
          .then(() => {
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      } else {
        updateHomeData(
          {
            gridSection: grid.filter((val) => val._id !== deleteId),
          },
          id
        )
          .then(() => {
            toast.success("Deleted Successfully.");
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      }
    }

    if (deleteFrom === "number") {
      if (numbers.length === 1) {
        updateHomeData({ numbers: [] }, id)
          .then(() => {
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      } else {
        updateHomeData(
          {
            numbers: numbers.filter((val) => val._id !== deleteId),
          },
          id
        )
          .then(() => {
            toast.success("Deleted Successfully.");
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      }
    }

    if (deleteFrom === "client") {
      if (clients.length === 1) {
        updateHomeData({ client: [] }, id)
          .then(() => {
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      } else {
        updateHomeData(
          {
            client: clients.filter((val) => val._id !== deleteId),
          },
          id
        )
          .then(() => {
            toast.success("Deleted Successfully.");
            getData();
          })
          .catch(() => {
            setLoading(false);
            toast.error("Something went wrong while deleting hero element.");
          });
      }
    }
  };

  const getFormData = async () => {
    try {
      const f_d = {
        title: formTitle,
        imageCaption: formImageCaption,
        imageAlt: formImageAlt,
        description: formDescription,
      };

      if (formImage.obj) {
        const res = await uploadImageApi(formImage.obj, "article");

        f_d.image = res.data.imageUrl;
      } else {
        f_d.image = formImage.url;
      }
      return f_d;
    } catch (err) {
      toast.error(err.response.data.message);
      setLoading(false);
      throw err;
    }
  };

  const handleUpdate = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const f_data = await getFormData();

        updateHomeData(
          {
            metaData: {
              metaTitle: metaTitle,
              metaImageUrl: metaImageUrl,
              canonicalUrl: canonicalUrl,
              metaDescription: metaDescription,
            },
            question: f_data,
            contactQuestions: contactQuestions.map((v) => ({
              question: v.question,
              options: v.options,
            })),
            relatedArticle: relatedBlogs,
            bottomSection,
          },
          id
        )
          .then(() => {
            setIsChanged(false);
            toast.success("Updated Successfully.");
            getData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response.data.message);
          });
      } catch (err) {}
    }
  };

  const validate = () => {
    if (!formImage.url) {
      toast.error("Form Image is required.");
      return false;
    }
    if (!formImageCaption) {
      toast.error("Form Image caption is required");
      return false;
    }
    if (!formImageAlt) {
      toast.error("Form Image Alt is required.");
      return false;
    }
    if (!formTitle) {
      toast.error("Form Title is required.");
      return false;
    }
    if (!formDescription) {
      toast.error("Form Description is required.");
      return false;
    }
    if (!bottomSection.left.heading) {
      toast.error("Left & Right CTA's Left Heading is required.");
      return false;
    }
    if (!bottomSection.left.buttonText) {
      toast.error("Left & Right CTA's Left Button Text is required.");
      return false;
    }
    if (!bottomSection.left.buttonUrl) {
      toast.error("Left & Right CTA's Left Button Url is required.");
      return false;
    }
    if (!isValidURL(bottomSection.left.buttonUrl)) {
      toast.error("Left & Right CTA's Left Button Url is invalid.");
      return false;
    }
    if (!bottomSection.right.heading) {
      toast.error("Left & Right CTA's Right Heading is required.");
      return false;
    }
    if (!bottomSection.right.buttonText) {
      toast.error("Left & Right CTA's Right Button Text is required.");
      return false;
    }
    if (!bottomSection.right.buttonUrl) {
      toast.error("Left & Right CTA's Right Button Url is required.");
      return false;
    }
    if (!isValidURL(bottomSection.right.buttonUrl)) {
      toast.error("Left & Right CTA's Right Button Url is invalid.");
      return false;
    }
    if (!metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }
    if (!metaImageUrl) {
      toast.error("Meta Image Url is required.");
      return false;
    }
    if (!isValidURL(metaImageUrl)) {
      toast.error("Please enter a valid meta image url.");
      return false;
    }
    if (!canonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }
    if (!isValidURL(canonicalUrl)) {
      toast.error("Please enter a valid Canonical Url.");
      return false;
    }
    if (!metaDescription) {
      toast.error("Meta Description is required.");
    }
    return true;
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => {
          setDeleteFrom("");
          setDeleteId("");
          setModal(false);
        }}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <Content>
        <ContentHead
          title="Homepage"
          showBtn1={isChanged}
          btn1Text={"Save"}
          btn1type="filled"
          btn1Name="btn1"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleUpdate();
            } else {
              setLoading(true);
              getData();
              setIsChanged(false);
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>
                Hero Carousel{" "}
                <button onClick={() => navigate("/home-carousel/add")}>
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              <Table
                head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
                body={hero}
                body_keys={["title", "action:delete"]}
                onRowClick={(e) => {
                  navigate(`/home-carousel/${e._id}`);
                }}
                onActionClick={(_, v2) => {
                  setDeleteFrom("hero");
                  setDeleteId(v2);
                  setModal(true);
                }}
                number={true}
              />
            </div>
            <div className="card grid">
              <h3>Form Section</h3>
              <div>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    transform: "translateX(5px)",
                    marginBottom: "10px",
                  }}
                >
                  Image
                  <span style={{ color: "#a3a3a3", fontSize: ".8rem" }}></span>
                  {formImage.url && (
                    <span
                      style={{
                        display: "inline-flex",
                        borderRadius: "10px",
                        marginLeft: "10px",
                        color: "#CB1829",
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setIsChanged(true);
                        setFormImage({ url: "", obj: "" });
                      }}
                      title="Delete image"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  )}
                </p>

                {!formImage.url ? (
                  <div
                    style={{
                      height: "50px",
                      width: "50px",
                      textAlign: "center",
                      background: "transparent",
                      border: "1px dashed grey",
                      borderRadius: "10px",
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    +
                    <input
                      type="file"
                      style={{
                        opacity: 0,
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        cursor: "pointer",
                      }}
                      accept="image/*"
                      onChange={(e) => {
                        setIsChanged(true);
                        setFormImage({
                          url: URL.createObjectURL(e.target.files[0]),
                          obj: e.target.files[0],
                        });
                      }}
                    ></input>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "45%",
                      aspectRatio: "16/9",
                      backgroundImage: `url('${formImage.url}')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      marginBottom: "40px",
                      marginTop: "10px",
                      borderRadius: "15px",
                      position: "relative",
                    }}
                  ></div>
                )}
              </div>
              {formImage.url && (
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Caption"}
                    value={formImageCaption}
                    onChange={(e) => {
                      setFormImageCaption(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Alt"}
                    value={formImageAlt}
                    onChange={(e) => {
                      setFormImageAlt(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                </div>
              )}
              <InputField
                type="text"
                isLabel={true}
                lable={"Heading"}
                value={formTitle}
                onChange={(e) => {
                  setFormTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setFormDescription(val);
                    setIsChanged(true);
                  }}
                  content={formDescription}
                  smallEditor={false}
                />
              </div>
              <h3>
                Form Questions
                <button
                  onClick={() => {
                    setContactQuestions((prev) => [
                      ...prev,
                      { question: "", options: [], tempText: "" },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              <>
                {contactQuestions.map((cq, index) => {
                  return (
                    <div className="sub_card grid" key={index}>
                      <FontAwesomeIcon
                        icon={faClose}
                        className="sub_card_close"
                        onClick={() => {
                          const temp = [...contactQuestions];
                          temp.splice(index, 1);
                          setContactQuestions(temp);
                          setIsChanged(true);
                        }}
                      />
                      <h3>Question {index + 1}</h3>
                      <InputField
                        type="text"
                        isLabel={true}
                        lable="Question"
                        value={cq.question}
                        onChange={(e) => {
                          const temp = [...contactQuestions];
                          temp[index].question = e.target.value;
                          setContactQuestions(temp);
                          setIsChanged(true);
                        }}
                      />
                      <div>
                        <InputField
                          type="text"
                          isLabel={true}
                          value={cq.tempText}
                          lable={"Options (Press Enter to add)"}
                          isRequired={false}
                          placeholder={""}
                          onChange={(e) => {
                            const temp = [...contactQuestions];
                            temp[index].tempText = e.target.value;
                            setContactQuestions(temp);
                            setIsChanged(true);
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              const temp = [...contactQuestions];
                              temp[index].options = [
                                ...temp[index].options,
                                temp[index].tempText,
                              ];
                              temp[index].tempText = "";
                              setContactQuestions(temp);
                              setIsChanged(true);
                            }
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          {cq.options.map((tag, i) => {
                            return (
                              <div
                                key={i}
                                style={{
                                  background: "var(--blue-light)",
                                  color: "var(--blue-dark)",
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {tag}
                                <FontAwesomeIcon
                                  icon={faClose}
                                  style={{
                                    color: "var(--blue-dark)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    console.log("clicked");
                                    let c_temp = [...contactQuestions];
                                    let o_temp = [...c_temp[index].options];
                                    o_temp.splice(i, 1);
                                    console.log(o_temp);
                                    c_temp[index].options = o_temp;
                                    setContactQuestions(c_temp);
                                    setIsChanged(true);
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            </div>
            <div className="card grid">
              <h3>
                Grid Section{" "}
                <button onClick={() => navigate("/grid-section/add")}>
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              <Table
                head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
                body={grid}
                body_keys={["title", "action:delete"]}
                onActionClick={(_, v2) => {
                  setDeleteFrom("grid");
                  setDeleteId(v2);
                  setModal(true);
                }}
                onRowClick={(e) => {
                  navigate(`/grid-section/${e._id}`);
                }}
                number={true}
              />
            </div>
            <div className="card grid">
              <h3>
                Numbers{" "}
                <button onClick={() => navigate("/number/add")}>
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              <Table
                head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
                body={numbers}
                body_keys={["title", "action:delete"]}
                onActionClick={(_, v2) => {
                  setDeleteFrom("number");
                  setDeleteId(v2);
                  setModal(true);
                }}
                onRowClick={(e) => {
                  navigate(`/number/${e._id}`);
                }}
                number={true}
              />
            </div>
            <div className="card grid">
              <h3>
                Clients{" "}
                <button onClick={() => navigate("/client/add")}>
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              <Table
                head={[{ title: "S.No." }, { title: "Title" }, { title: "" }]}
                body={clients}
                body_keys={["clientName", "action:delete"]}
                onActionClick={(_, v2) => {
                  setDeleteFrom("client");
                  setDeleteId(v2);
                  setModal(true);
                }}
                onRowClick={(e) => {
                  navigate(`/client/${e._id}`);
                }}
                number={true}
              />
            </div>
            {/* Related Articles */}
            <div className="card grid">
              <h3>Latest Articles</h3>
              <InputField
                type="select"
                options={blogs.filter((val) => {
                  const temp = relatedBlogs.filter((v) => v === val._id);
                  return temp.length === 0 ? true : false;
                })}
                accessText="blogTitle"
                accessValue="_id"
                value=""
                onChange={(e) => {
                  setRelatedBlogs((prev) => [...prev, e.target.value]);
                  setIsChanged(true);
                }}
              />
              <div className="grid_3">
                {relatedBlogs.map((value, index) => {
                  return (
                    <div key={index} className="sub_card">
                      <FontAwesomeIcon
                        icon={faClose}
                        className="sub_card_close"
                        onClick={() => {
                          let temp = [...relatedBlogs];
                          temp.splice(index, 1);
                          setRelatedBlogs(temp);
                          setIsChanged(true);
                        }}
                      />
                      <img
                        style={{
                          width: "100%",
                          aspectRatio: "1/1",
                          objectFit: "cover",
                        }}
                        src={
                          blogs.filter((val) => val._id === value)[0]?.blogImage
                        }
                        alt=""
                      />
                      <p>
                        {blogs.filter((val) => val._id === value)[0]?.blogTitle}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="card grid">
              <h3>Left & Right CTA</h3>
              <InputField
                isLabel={true}
                lable="Left Heading"
                value={bottomSection.left.heading}
                onChange={(e) => {
                  setBottomSection((prev) => ({
                    ...prev,
                    left: { ...prev.left, heading: e.target.value },
                  }));
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <InputField
                  isLabel={true}
                  lable="Left Button Text"
                  value={bottomSection.left.buttonText}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      left: { ...prev.left, buttonText: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
                <InputField
                  isLabel={true}
                  lable="Left Button URL"
                  value={bottomSection.left.buttonUrl}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      left: { ...prev.left, buttonUrl: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
              </div>
              <InputField
                isLabel={true}
                lable="Right Heading"
                value={bottomSection.right.heading}
                onChange={(e) => {
                  setBottomSection((prev) => ({
                    ...prev,
                    right: { ...prev.right, heading: e.target.value },
                  }));
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <InputField
                  isLabel={true}
                  lable="Right Button Text"
                  value={bottomSection.right.buttonText}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      right: { ...prev.right, buttonText: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
                <InputField
                  isLabel={true}
                  lable="Right Button URL"
                  value={bottomSection.right.buttonUrl}
                  onChange={(e) => {
                    setBottomSection((prev) => ({
                      ...prev,
                      right: { ...prev.right, buttonUrl: e.target.value },
                    }));
                    setIsChanged(true);
                  }}
                />
              </div>
            </div>
            <div className="card grid">
              <h3>Meta Data</h3>
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default Home;
